import { memo, HTMLAttributes } from "react";
import { StaticImage } from "../StaticImage";
import { useStyles } from "./ServiceSelection.style";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { HomepageMd } from "../../../models/homepage";

export interface IServiceSelectionItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  launchpads: string[];
  title: string;
  onClick: () => void;
}

const ServiceSelectionItemComponent: React.FC<
  IServiceSelectionItemProps & HTMLAttributes<HTMLDivElement>
> = ({ onClick, launchpads, title, ...otherProps }) => {
  const classes = useStyles();
  const icons = HomepageMd.getLaunchpadIcons(launchpads);

  if (launchpads.length === 0) return;

  return (
    <div {...otherProps} className={classes.rowService} onClick={onClick}>
      <Typography variant={TypographyVariant.BodyB3Bold}>{title}</Typography>
      <div className={classes.launchpads}>
        {icons.map(({ id, src }, idx) => (
          <StaticImage
            key={id + idx}
            src={src.src1x}
            src2x={src.src2x}
            src3x={src.src3x}
            alt={`${id} service`}
            width={80}
            height={80}
          />
        ))}
      </div>
    </div>
  );
};

export const ServiceSelectionItem = memo(ServiceSelectionItemComponent);
